module.exports = __webpack_public_path__ + "static/media/dokia-recoveryEmailSent.ccfdb565.svg";